import { ReactNode } from 'react';
import { useAtom } from 'jotai';
import { onboardingAtom, useOnBoardingWorkspaceValidation } from './state';

function OnboardingWrapper({
  children,
  fallbackToImportCSV = false,
}: {
  children: ReactNode;
  fallbackToImportCSV?: boolean;
}) {
  useOnBoardingWorkspaceValidation(fallbackToImportCSV);

  const [{ workspace }] = useAtom(onboardingAtom);

  // if no workspace is set, we should not render the page
  // useOnBoardingWorkspaceValidation will setup the workspace in the onboarding state if it is in the url
  // and redirect to home if the workspace is not in the list of workspaces
  if (!workspace) {
    return null;
  }

  return <>{children}</>;
}

export default OnboardingWrapper;
